import React, { useEffect, useState, useRef } from "react";
import "./conclave css files/heroconclavemain.css";
import NavbarConclave from "./NavbarConclave";
import { eventRegistration } from "../../services/api";
import Alertbox from "../../components/alertbox/Alertbox";
import AlertCustDialogBox from "../../components/alertbox/AlertCustDialogBox";

const future_global_text = require("../../assets/conclave assets/future_global_text.svg");
const design1 = require("../../assets/conclave assets/form_dots.png");
const design2 = require("../../assets/conclave assets/gray_dots.png");

function HeroSectionConclave() {
  const [alertToggleModal, setAlertToggleModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    designation: "",
    organization: "",
    email: "",
    phone: "",
    sponsorship_query: "",
  });
  useEffect(() => {}, [formData]);

  async function handleSubmit(e) {
    e.preventDefault();

    let response = await eventRegistration({
      name: formData.name,
      designation: formData.designation,
      organization: formData.organization,
      email: formData.email,
      phone: formData.phone,
      sponsorship_query: formData.sponsorship_query,
    });

    if (response === "success") {
      setFormData({
        name: "",
        designation: "",
        organization: "",
        email: "",
        phone: "",
        sponsorship_query: "",
      });
      setAlertToggleModal(true);
      setTimeout(() => {
        setAlertToggleModal(false);
      }, 2000);
    }
  }
  return (
    <section className="hero_section_conclave_main_container">
      <NavbarConclave />
      <div className="hero_section_under_container">
        <div className="hero_flex_container">
          <div className="first_hero_section_container">
            <p className="title_txt_dynamic">
              DYNAMIC WORLD EDUCATION COMMUNITY
            </p>
            <p className="title_txt_dynamic">PRESENTS</p>
            <div className="future_global_text_container">
              <img src={future_global_text.default} alt="future_text" />
            </div>
            <p className="title_txt_dynamic1">
              BE THE PART OF AN ULTIMATE EDUCATION EXTRAVAGANZA
            </p>

            <button className="btn_nine_text">
              9<span className="small_text_th">th</span> June, Roseate House,
              New Delhi
            </button>
          </div>
          <div className="sec_hero_section_container">
            <div className="blue_container_for_register">
              <div className="design_text_container">
                <div className="design_container_register">
                  <img src={design1} className="design_self" alt="design" />
                </div>

                <p className="register_conclave_heading_text">
                  REGISTER FOR CONCLAVE
                </p>
              </div>

              <div className="all_text_input_container">
                <form
                  className="form_conclave_container"
                  onSubmit={handleSubmit}
                >
                  <input
                    type="text"
                    id="name"
                    name="name"
                    autoComplete="off"
                    placeholder="Name *"
                    className="conclave_register_input"
                    value={formData.name}
                    onChange={(e) =>
                      setFormData((preVal) => ({
                        ...preVal,
                        name: e.target.value,
                      }))
                    }
                  />
                  <br />
                  <input
                    type="text"
                    id="name"
                    autoComplete="off"
                    name="name"
                    placeholder="Designation *"
                    className="conclave_register_input"
                    value={formData.designation}
                    onChange={(e) =>
                      setFormData((preVal) => ({
                        ...preVal,
                        designation: e.target.value,
                      }))
                    }
                  />
                  <br />
                  <input
                    type="text"
                    autoComplete="off"
                    id="name"
                    name="name"
                    placeholder="Organization *"
                    className="conclave_register_input"
                    value={formData.organization}
                    onChange={(e) =>
                      setFormData((preVal) => ({
                        ...preVal,
                        organization: e.target.value,
                      }))
                    }
                  />
                  <br />
                  <input
                    type="email"
                    id="name"
                    autoComplete="off"
                    name="name"
                    placeholder="Email *"
                    className="conclave_register_input"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData((preVal) => ({
                        ...preVal,
                        email: e.target.value,
                      }))
                    }
                  />
                  <br />
                  <input
                    type="number"
                    autoComplete="off"
                    id="number"
                    name="number"
                    placeholder="Phone *"
                    className="conclave_register_input"
                    value={formData.phone}
                    onChange={(e) =>
                      setFormData((preVal) => ({
                        ...preVal,
                        phone: e.target.value,
                      }))
                    }
                  />
                  <br />

                  <select
                    name="queries"
                    id="queries"
                    className="conclave_register_input"
                    value={formData.sponsorship_query}
                    onChange={(e) => {
                      setFormData((preVal) => ({
                        ...preVal,
                        sponsorship_query: e.target.value,
                      }));
                    }}
                  >
                    <option value="">Sponsorship Query *</option>
                    <option value="Yes">YES</option>
                    <option value="No">NO</option>
                  </select>

                  <div className="register_now_btn_container">
                    <button className="register_now_btn">REGISTER NOW</button>
                  </div>
                </form>
              </div>
              <div className="design2_container">
                <img src={design2} alt="design" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <AlertCustDialogBox
        dialogHeaderName=""
        open={alertToggleModal}
        onClose={() => {
          setAlertToggleModal(false);
        }}
      >
        <Alertbox />
      </AlertCustDialogBox>
    </section>
  );
}

export default HeroSectionConclave;
